// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ijCsA","colBig":"styles_colBig__2NqZ4","colSmall":"styles_colSmall__1X8dD"};